export default "__VITE_ASSET__iQlooVsz__"